import ChargePointPopupArea from "@/pages/comp/basic/point/common/charge_point_popup";
function ChargePointPopup(props: any) {
  let myProps = {
    closePopup:()=>{},
    refreshData:(inData:any)=>{},
    ...props
  };

  return (
    <div>
      <ChargePointPopupArea
        {...myProps}
      ></ChargePointPopupArea>
    </div>
  );
};
export default ChargePointPopup;